import React from "react";
import {
  Modal,
  Form,
  Input,
  Button,
  Radio,
  Dropdown,
  Space,
  Select,
} from "antd";
import moment from "moment";

// import useClientStore from "../../store/clientModal.store";
import useSkillMatrixStore from "../../store/skillMatrix.store";
import useJDStore from "../../store/jd.store";
import "./skillMatrixModal.scss";

export default function SkillMatrixModal({ qhjid }) {
  const { handleSkillAdd, isModalOpen, handleModalCancel } =
    useSkillMatrixStore();
  const { getJdByID } = useJDStore();
  const moment = require("moment");
  const date = new Date();

  const encodeJson = (values) => {
    let encodedJsonValues = {};
    console.log("These are the values", values);

    //now fill the parameters
    encodedJsonValues = {};
    encodedJsonValues.skill = values.skillname;
    encodedJsonValues.selfrating = parseInt(values.selfrating);
    encodedJsonValues.mentionedexp = parseInt(values.mentionedexp);
    encodedJsonValues.weightage = parseInt(values.weightage);

    return encodedJsonValues;
  };

  const handleFormSubmit = async (value) => {
    const jasonValues = encodeJson(value);
    console.log("Encoded data", jasonValues);
    await handleSkillAdd(jasonValues, qhjid);
    getJdByID(qhjid);
    handleModalCancel();
  };

  return (
    <Modal
      title={"Add New Skill"}
      visible={isModalOpen}
      footer={null}
      onCancel={handleModalCancel}
      className="subUserAddModel-title"
    >
      <Form
        labelCol={{ flex: "150px" }}
        labelAlign="left"
        labelWrap
        wrapperCol={{ flex: 1 }}
        colon={false}
        onFinish={handleFormSubmit}
      >
        <Form.Item
          rules={[
            {
              required: true,
              message: "Please Add Skill",
            },
          ]}
          label="Skill"
          name="skillname"
        >
          <Input className="subUserAddModel-input" />
        </Form.Item>
        <Form.Item
          rules={[
            {
              required: true,
              maxLength: 10,
              message: "Please Add Min Experience",
            },
          ]}
          label="Min Experience"
          name="mentionedexp"
        >
          <Input className="subUserAddModel-input" />
        </Form.Item>

        <Form.Item
          rules={[
            {
              required: true,
              message: "Please Add Max Rating",
            },
          ]}
          label="Max Rating"
          name="selfrating"
        >
          <Input className="subUserAddModel-input" />
        </Form.Item>
        <Form.Item
          rules={[
            {
              required: true,
              message: "Please Add Weightage",
            },
          ]}
          label="Weightage"
          name="weightage"
        >
          <Input className="subUserAddModel-input" />
        </Form.Item>

        <Button htmlType="submit" type="primary">
          Submit
        </Button>
      </Form>
    </Modal>
  );
}
